import baseStyle from "./baseStyle";

const theme = {
  ...baseStyle,
};

export default theme;
